import Script from "next/script";
import React, { Fragment } from "react";

export default function MTM() {
  const isProductionEnv =
    process.env.NODE_ENV && process.env.NODE_ENV !== "development";

  return (
    <Fragment>
      {isProductionEnv ? (
        <React.Fragment>
          <Script
            strategy="lazyOnload"
            id="matomo-script"
            dangerouslySetInnerHTML={{
              __html: `var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="https://matomo.matlabsite.com/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '1']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();`,
            }}
          />
        </React.Fragment>
      ) : null}
    </Fragment>
  );
}
